<template>
  <div>
    {{syncRate}} %
  </div>
</template>

<script>
import connections from '../../../config/connections'
import axios from 'axios'

export default {
  name: 'StatusView',
  props: {
    connection: {
      required: true
    }
  },
  data () {
    return {syncRate: 0}
  },
  mounted () {
    setInterval(() => this.getSyncRate(), 2000)
  },
  methods: {
    async getLocalDb (conn) {
      let url = conn.host.split('//')[1]
      console.log('Conectando ao banco local', url)
      let localDbInfo = await new Promise((resolve, reject) => {
        axios.get('http://' + conn.user + ':' + conn.pass + '@' + url + '/' + conn.db).then(response => {
          resolve(response.data)
        })
      })
      return localDbInfo
    },
    async getRemoteDb (conn) {
      let url = conn.remote_host.split('//')[1]
      console.log('Conectando ao banco remoto', url)
      let dbRemoteInfo = await new Promise((resolve, reject) => {
        axios.get('http://' + conn.remote_user + ':' + conn.remote_pass + '@' + url + '/' + conn.remote_db).then(response => {
          resolve(response.data)
        })
      })
      return dbRemoteInfo
    },
    async getSyncRate () {
      let conn = connections[this.connection]
      let dbLocalInfo = await this.getLocalDb(conn)
      let dbRemoteInfo = await this.getRemoteDb(conn)
      let localUpdateSeq = dbLocalInfo.doc_count
      let remoteUpdateSeq = dbRemoteInfo.doc_count
      this.syncRate = ((100 - ((remoteUpdateSeq - localUpdateSeq) / remoteUpdateSeq) * 100).toFixed(2))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/StatusReplications/StatusReplicationView.vue